exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".menu-container {\n    margin-left: auto;\n    margin-right: auto;\n    width: 75vh;\n}\n\n@media screen and (max-aspect-ratio: 3/4) {\n    .menu-container {\n        width: 100vw;\n    };\n}\n", ""]);
